import MealtimeDetailsModal from './MealtimeDetailsModal';
export default MealtimeDetailsModal;
